// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const LOGINFAILED = 'LOGINFAILED';
export const UPDATE_TOKENS = 'UPDATE_TOKENS';
